import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M16.441 1.72a.624.624 0 1 1 1.118.56l-10 20a.624.624 0 1 1-1.118-.56l10-20Z" />
  </svg>
`;
